export default __webpack_public_path__ + "static/media/j4.19adb794.png";